import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import UnityWebViewer from "../components/UnityWebViewer";


const ExperiencePage = () => {
  const { experienceId } = useParams();
  const [searchParams] = useSearchParams();

  const userData = {
    name: searchParams.get("userName"),
    id: searchParams.get("userId"),
    organizationId: searchParams.get("organizationId"),
    subscriptionStatus: searchParams.get("subscriptionStatus"),
  };

  return (
    <div className="App">
      {/* <h2>Experience ID: {experienceId}</h2> */}
      <UnityWebViewer experienceId={experienceId} userData={userData} />
    </div>
  );
};

export default ExperiencePage;
